var _baseUrl = '';
/**
 * @deprecated Unused as of version 8
 */
export function getResourceUrl(url) {
    return _baseUrl + url;
}
/**
 * @deprecated Unused as of version 8
 */
export function setBaseUrl(baseUrl) {
    _baseUrl = baseUrl;
}
//# sourceMappingURL=resources.js.map